export default {"src":"/_next/static/image/public/images/ic_download.3926494537acf7750ebced7e732b0a06.svg","height":19,"width":19};